// react-native-popup-menu's MenuProvider uses childContextTypes (REMOVED in
// React 19) and wraps the entire app in src/Main.js — so on web it blanks
// everything. Shim the wrappers as passthroughs (render children) and the
// dropdown parts as null. Menus won't open on web, but the app renders.
const React = require("react");
const Pass = (props) => React.createElement(React.Fragment, null, props.children);
const Null = () => null;

module.exports = {
  __esModule: true,
  default: Null,
  MenuProvider: Pass, // wraps RootNavigation — MUST render children
  Menu: Pass,
  MenuTrigger: Pass, // wraps the trigger control — keep it visible
  MenuOptions: Null, // the dropdown — hidden until opened anyway
  MenuOption: Null,
  withMenuContext: (C) => C,
  renderers: {
    ContextMenu: Null, SlideInMenu: Null, Popover: Null, NotAnimatedContextMenu: Null,
  },
};
